import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import chargePeriodDropdown from '../../../../Utilities/Constants/ChargePeriodDropdown';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
interface IProps {
    isReadOnly: boolean
}
export default function TravelPlanCarParkingV1({ isReadOnly }: IProps) {

    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;

    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {hasValues(["limitedAvailabilityOfOnSiteSpaces"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="limitedAvailabilityOfOnSiteSpaces" label="Limited availability of on-ite parking spaces (on-site parking supply is set at less than demand for a target group of Travel Plan)" readOnly={isReadOnly} options={yesNoDropdown} />
                        </Grid>
                    )}

                    {hasValues(["parkingChargesForParticularGroup", "parkingChargesForParticularGroupMonth", "parkingChargesForParticularGroupYear", "parkingChargesForParticularGroupCapitalCost", "parkingChargesForParticularGroupAnnualCost", "parkingChargesForParticularGroupCharge", "parkingChargesForParticularGroupPeriod"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="parkingChargesForParticularGroup" label="Charging for parking for Travel Plan target group (e.g. stff, patients, visitors, etc)" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'parkingChargesForParticularGroupMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'parkingChargesForParticularGroupYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="parkingChargesForParticularGroupCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="parkingChargesForParticularGroupAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                            <RenderTextField name="parkingChargesForParticularGroupCharge" label="Annual operating cost" readOnly={isReadOnly} />
                            <RenderSelectField name="parkingChargesForParticularGroupPeriod" label="Annual operating cost" readOnly={isReadOnly} options={chargePeriodDropdown} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["parkingPermitEligibilityRestrictions", "parkingPermitEligibilityRestrictionsMonth", "parkingPermitEligibilityRestrictionsYear", "parkingPermitEligibilityRestrictionsCapitalCost", "parkingPermitEligibilityRestrictionsAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="parkingPermitEligibilityRestrictions" label="Parking permit eligibility restrictions (e.g. only staff without viable public transport alternative are issues with a permit)" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'parkingPermitEligibilityRestrictionsMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'parkingPermitEligibilityRestrictionsYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="parkingPermitEligibilityRestrictionsCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="parkingPermitEligibilityRestrictionsAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["parkingEnforcementMeasuresInPlace", "parkingEnforcementMeasuresInPlaceMonth", "parkingEnforcementMeasuresInPlaceYear", "parkingEnforcementMeasuresInPlaceCapitalCost", "parkingEnforcementMeasuresInPlaceAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="parkingEnforcementMeasuresInPlace" label="Parking enforcement (e.g. barrier control, pakring, attendants, clamping, ticketing) on-site" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'parkingEnforcementMeasuresInPlaceMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'parkingEnforcementMeasuresInPlaceYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="parkingEnforcementMeasuresInPlaceCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="parkingEnforcementMeasuresInPlaceAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                </Grid>

                <Grid size={4} container>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Typography variant={"h6"}>Additional Comments</Typography>
                        </Grid>
                        <RenderTextField name="parkingComments" readOnly={isReadOnly} multiLine={true} rows={4} inputSize={12} alwaysShow={true} />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
